var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group mb-3 w-100",attrs:{"role":"group"}},[_vm._m(0),_c('input',{ref:"dateRangePickerInput",staticClass:"form-control",attrs:{"type":"text"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Choose Date")])])
}]

export { render, staticRenderFns }